import axiosService from './axios.service';
import ResponseService from './response.service';

const getUserPayoutList = async (
  _perPage,
  _page,
  commonSearch,
  project_id,
  user_id,
  payout_id,
  field,
  order,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'project_payouts/users_payout_list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        project_id: project_id,
        user_id: user_id,
        payout_id: payout_id,
        sortBy: field,
        sortOrder: order,
      },
    };
    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const listUpcomingPayouts = async (project_id) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'project_payouts/upcoming',
      isAuthorized: true,
      params: {
        project_id: project_id,
      },
    };
    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const PayoutService = {
  getUserPayoutList,
  listUpcomingPayouts,
};

export default PayoutService;
